import { MapPin } from "lucide-react";
import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

import { EMPTY_VALUE } from "@/constants";
import { orEmptyValue } from "@/lib/hcbb-cost-estimator-utils";

/** One icon-led line of detail. The glyph repeats what the text says. */
export const HcbbDetailLine = ({
  icon: Icon,
  children,
}: {
  icon: LucideIcon;
  children: ReactNode;
}) => (
  <p className="flex min-w-0 items-start gap-2 text-sm text-gray-600">
    <Icon aria-hidden="true" height={16} className="relative top-1 shrink-0" />
    <span className="min-w-0">{children}</span>
  </p>
);

/**
 * Where a facility or provider is, and how far the search measured it at.
 *
 * Lives here rather than beside the detail header because a result row shows
 * the same thing — the two were written separately and drifted, which is how
 * the row ended up printing "NA (approx.)" for a payload with no distance.
 *
 * The distance line is dropped rather than printed when there is no radius: an
 * approximation of nothing helps no one.
 */
export const HcbbDetailAddress = ({
  address,
  displayRadius,
}: {
  address: string;
  displayRadius: string;
}) => {
  const radius = orEmptyValue(displayRadius);

  return (
    <HcbbDetailLine icon={MapPin}>
      {orEmptyValue(address)}
      {radius !== EMPTY_VALUE && (
        <>
          <br /> {radius} (approx.)
        </>
      )}
    </HcbbDetailLine>
  );
};
